module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/mastercard-930ca54c67288e31c5136c952e16f9ee.png";